// extracted by mini-css-extract-plugin
export default {"skillbadge":"skills_skillbadge__xvtCG"};